 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TOC from '@/components/toc'
 import A_CHAPTER801STRANGESTEP from '@/components/0_chapter801strangestep'
 import A_CHAPTER802ACTIVATINGTHEDEMONICPALACE from '@/components/1_chapter802activatingthedemonicpalace'
 import A_CHAPTER803WHOWASTRAPPEDMORETHANADECADEAGO from '@/components/2_chapter803whowastrappedmorethanadecadeago'
 import A_CHAPTER804ICANSAVETHEM from '@/components/3_chapter804icansavethem'
 import A_CHAPTER805AWAKENING from '@/components/4_chapter805awakening'
 import A_CHAPTER806THEPASSAGEBEHINDTHERESTRICTION from '@/components/5_chapter806thepassagebehindtherestriction'
 import A_CHAPTER807MARTIALSKILLSTONEFOREST from '@/components/6_chapter807martialskillstoneforest'
 import A_CHAPTER808WINDANDCLOUDRISEAGAIN from '@/components/7_chapter808windandcloudriseagain'
 import A_CHAPTER809FOURCRISES from '@/components/8_chapter809fourcrises'
 import A_CHAPTER810CANALICULAR from '@/components/9_chapter810canalicular'
 import A0_CHAPTER811HEAVENSWALLOWINGPYTHON from '@/components/10_chapter811heavenswallowingpython'
 import A1_CHAPTER812ASHES from '@/components/11_chapter812ashes'
 import A2_CHAPTER813ESCAPE from '@/components/12_chapter813escape'
 import A3_CHAPTER814ITREALLYISHIM from '@/components/13_chapter814itreallyishim'
 import A4_CHAPTER815CONFUSION from '@/components/14_chapter815confusion'
 import A5_CHAPTER816FLOWERINGHANCHENSHAND from '@/components/15_chapter816floweringhanchenshand'
 import A6_CHAPTER817SEAL from '@/components/16_chapter817seal'
 import A7_CHAPTER818GOLDENLOTUSSEAT from '@/components/17_chapter818goldenlotusseat'
 import A8_CHAPTER819IAMEVILANDIBURYTHEHEARTOFTHEDEVIL from '@/components/18_chapter819iamevilandiburytheheartofthedevil'
 import A9_CHAPTER820CRISISATTACKS from '@/components/19_chapter820crisisattacks'
 import A0_CHAPTER821THEQUALIFICATIONOFCONDITIONS from '@/components/20_chapter821thequalificationofconditions'
 import A1_CHAPTER822ROLL from '@/components/21_chapter822roll'
 import A2_CHAPTER823CANGTAIJI from '@/components/22_chapter823cangtaiji'
 import A3_CHAPTER824FACETOFACECONFRONTATION from '@/components/23_chapter824facetofaceconfrontation'
 import A4_CHAPTER825FOURIMAGESOFSUPPRESSINGYINANDYANG from '@/components/24_chapter825fourimagesofsuppressingyinandyang'
 import A5_CHAPTER826CANGTAIJISSTRENGTH from '@/components/25_chapter826cangtaijisstrength'
 import A6_CHAPTER827STORMATTACK from '@/components/26_chapter827stormattack'
 import A7_CHAPTER828CANGTAIJISLASTTRUMPCARD from '@/components/27_chapter828cangtaijislasttrumpcard'
 import A8_CHAPTER829KILLCANGTAIJI from '@/components/28_chapter829killcangtaiji'
 import A9_CHAPTER830VENERABLEONEINTHESWORD from '@/components/29_chapter830venerableoneinthesword'
 import A0_CHAPTER831CASANOVA from '@/components/30_chapter831casanova'
 import A1_CHAPTER832OPENCASANOVA from '@/components/31_chapter832opencasanova'
 import A2_CHAPTER833PALACESILVERTOWER from '@/components/32_chapter833palacesilvertower'
 import A3_CHAPTER834STRANGEPILLAR from '@/components/33_chapter834strangepillar'
 import A4_CHAPTER835GOLDENPAGODA from '@/components/34_chapter835goldenpagoda'
 import A5_CHAPTER836THOUGHTPROVOKING from '@/components/35_chapter836thoughtprovoking'
 import A6_CHAPTER837SEEDOFIMMORTALSPIRIT from '@/components/36_chapter837seedofimmortalspirit'
 import A7_CHAPTER838CASANOVALIUFEIXU from '@/components/37_chapter838casanovaliufeixu'
 import A8_CHAPTER839LIKEADREAMORADREAMHEWASSTILLDRUNKANDHADYETTOWAKEUP from '@/components/38_chapter839likeadreamoradreamhewasstilldrunkandhadyettowakeup'
 import A9_CHAPTER840INNERMOST from '@/components/39_chapter840innermost'
 import A0_CHAPTER841THEONLYPERSONWHOUNDERSTANDS from '@/components/40_chapter841theonlypersonwhounderstands'
 import A1_CHAPTER842DREAMDISILLUSIONMENTKILLINGARRAYACTIVATED from '@/components/41_chapter842dreamdisillusionmentkillingarrayactivated'
 import A2_CHAPTER843ADREAMOFTHEYELLOWRIVER from '@/components/42_chapter843adreamoftheyellowriver'
 import A3_CHAPTER844ROBBING from '@/components/43_chapter844robbing'
 import A4_CHAPTER845SEVENEMOTIONSANDSIXDESIRES from '@/components/44_chapter845sevenemotionsandsixdesires'
 import A5_CHAPTER846THEORIGINOFEROTICPALACE from '@/components/45_chapter846theoriginoferoticpalace'
 import A6_CHAPTER847MYSTERY from '@/components/46_chapter847mystery'
 import A7_CHAPTER848HEAVENBEAUTYYUFENGLAN from '@/components/47_chapter848heavenbeautyyufenglan'
 import A8_CHAPTER849LIKEADREAMORAFANTASYABEAUTYLIKEAJADE from '@/components/48_chapter849likeadreamorafantasyabeautylikeajade'
 import A9_CHAPTER850ASUDDENCHANGEOFHEART from '@/components/49_chapter850asuddenchangeofheart'
 import A0_CHAPTER851ZHONGLISURNAME from '@/components/50_chapter851zhonglisurname'
 import A1_CHAPTER852IHAVEACONDITION from '@/components/51_chapter852ihaveacondition'
 import A2_CHAPTER853THEWHOLEUNIVERSEWHOADVOCATEUPSANDDOWNS from '@/components/52_chapter853thewholeuniversewhoadvocateupsanddowns'
 import A3_CHAPTER854SHOCKINGTHEWORLD from '@/components/53_chapter854shockingtheworld'
 import A4_CHAPTER855SAINTSTERRACE from '@/components/54_chapter855saintsterrace'
 import A5_CHAPTER856BEFORETHEGREATWAR from '@/components/55_chapter856beforethegreatwar'
 import A6_CHAPTER857NOITWASLONGHABITAT from '@/components/56_chapter857noitwaslonghabitat'
 import A7_CHAPTER858DATEOFTHEDECISIVEBATTLE from '@/components/57_chapter858dateofthedecisivebattle'
 import A8_CHAPTER859AGATHERINGOFDRAGONSAMEETINGOFTHEWINDANDTHECLOUDS from '@/components/58_chapter859agatheringofdragonsameetingofthewindandtheclouds'
 import A9_CHAPTER860THEFIRSTBATTLEHADBEGUN from '@/components/59_chapter860thefirstbattlehadbegun'
 import A0_CHAPTER861THEGREATDAOWASTHESIMPLESTTHEHEARTREFINEDTHEWORLD from '@/components/60_chapter861thegreatdaowasthesimplesttheheartrefinedtheworld'
 import A1_CHAPTER862HEAVENSPRIDEBATTLEEVILSEED from '@/components/61_chapter862heavenspridebattleevilseed'
 import A2_CHAPTER863SWORDTECHNIQUESANDTECHNIQUES from '@/components/62_chapter863swordtechniquesandtechniques'
 import A3_CHAPTER864HIDE from '@/components/63_chapter864hide'
 import A4_CHAPTER865YEWEINISTRUESTRENGTH from '@/components/64_chapter865yeweinistruestrength'
 import A5_CHAPTER866FIGHTINGOUTBREAK from '@/components/65_chapter866fightingoutbreak'
 import A6_CHAPTER867LONGHABITATDOUBLE from '@/components/66_chapter867longhabitatdouble'
 import A7_CHAPTER868THEBATTLEOFTHEPEAK from '@/components/67_chapter868thebattleofthepeak'
 import A8_CHAPTER869THEFIGHTINGWASFIERCE from '@/components/68_chapter869thefightingwasfierce'
 import A9_CHAPTER870VICIOUSLEIMINGTIAN from '@/components/69_chapter870viciousleimingtian'
 import A0_CHAPTER871WHOWILLBETHEWINNEROFTHISFIGHT from '@/components/70_chapter871whowillbethewinnerofthisfight'
 import A1_CHAPTER872HEAVENSHAKINGCHANGE from '@/components/71_chapter872heavenshakingchange'
 import A2_CHAPTER873HANCHENWOKEUP from '@/components/72_chapter873hanchenwokeup'
 import A3_CHAPTER874DEFEATWITHONEMOVE from '@/components/73_chapter874defeatwithonemove'
 import A4_CHAPTER875HISNAMEWASHANCHEN from '@/components/74_chapter875hisnamewashanchen'
 import A5_CHAPTER876SHOCKINGWARS from '@/components/75_chapter876shockingwars'
 import A6_CHAPTER877SHENYU from '@/components/76_chapter877shenyu'
 import A7_CHAPTER878YOUWILLBEVERYDISGRACED from '@/components/77_chapter878youwillbeverydisgraced'
 import A8_CHAPTER879POWERFUL from '@/components/78_chapter879powerful'
 import A9_CHAPTER880SWORDLORD from '@/components/79_chapter880swordlord'
 import A0_CHAPTER881SWORDINTENTMANIFESTATION from '@/components/80_chapter881swordintentmanifestation'
 import A1_CHAPTER882ZHONGSHANWINDANDRAINTHESWORDDISAPPEARS from '@/components/81_chapter882zhongshanwindandrainthesworddisappears'
 import A2_CHAPTER883THESWORDSAINTWASSORROWFULBUTTHESWORDFINGERWASSTILLALIVE from '@/components/82_chapter883theswordsaintwassorrowfulbuttheswordfingerwasstillalive'
 import A3_CHAPTER884LETSSEEWHOWILLSEEKDEATH from '@/components/83_chapter884letsseewhowillseekdeath'
 import A4_CHAPTER885SWORDSOULSWORDSOULSLASH from '@/components/84_chapter885swordsoulswordsoulslash'
 import A5_CHAPTER886THESTRUGGLEBETWEENTHETIANXIESHADCOMETOANEND from '@/components/85_chapter886thestrugglebetweenthetianxieshadcometoanend'
 import A6_CHAPTER887IKILLEDHIM from '@/components/86_chapter887ikilledhim'
 import A7_CHAPTER888ASUDDENSURPRISE from '@/components/87_chapter888asuddensurprise'
 import A8_CHAPTER889WHOEVERDARESTOSTOPMEIWILLKILL from '@/components/88_chapter889whoeverdarestostopmeiwillkill'
 import A9_CHAPTER890THESKYMANSIONCHASEDAFTERHIM from '@/components/89_chapter890theskymansionchasedafterhim'
 import A0_CHAPTER891IFYOUWANTTOADDTOYOURCRIMESYOUWILLHAVENOTHINGTOSAY from '@/components/90_chapter891ifyouwanttoaddtoyourcrimesyouwillhavenothingtosay'
 import A1_CHAPTER892KILLINGTOSILENCE from '@/components/91_chapter892killingtosilence'
 import A2_CHAPTER893FIERCEFIGHTINGPUXIULUO from '@/components/92_chapter893fiercefightingpuxiuluo'
 import A3_CHAPTER894YOURETHEONEWHOSGOINGTOKILLME from '@/components/93_chapter894youretheonewhosgoingtokillme'
 import A4_CHAPTER895WISEFIGHTING from '@/components/94_chapter895wisefighting'
 import A5_CHAPTER896IMRICH from '@/components/95_chapter896imrich'
 import A6_CHAPTER897ASTRANGEPICTURE from '@/components/96_chapter897astrangepicture'
 import A7_CHAPTER898ITSNOTSOMETHINGTHATHUMANSDO from '@/components/97_chapter898itsnotsomethingthathumansdo'
 import A8_CHAPTER899SUPEREXPLOSION from '@/components/98_chapter899superexplosion'
 import A9_CHAPTER900THEWRATHOFPUXINGHE from '@/components/99_chapter900thewrathofpuxinghe'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/toc",
 			"name" : "toc",
 			"component" : TOC
 		},
 		{
 			"path" : "/0_chapter801strangestep",
 			"name" : "0_chapter801strangestep",
 			"component" : A_CHAPTER801STRANGESTEP
 		},
 		{
 			"path" : "/1_chapter802activatingthedemonicpalace",
 			"name" : "1_chapter802activatingthedemonicpalace",
 			"component" : A_CHAPTER802ACTIVATINGTHEDEMONICPALACE
 		},
 		{
 			"path" : "/2_chapter803whowastrappedmorethanadecadeago",
 			"name" : "2_chapter803whowastrappedmorethanadecadeago",
 			"component" : A_CHAPTER803WHOWASTRAPPEDMORETHANADECADEAGO
 		},
 		{
 			"path" : "/3_chapter804icansavethem",
 			"name" : "3_chapter804icansavethem",
 			"component" : A_CHAPTER804ICANSAVETHEM
 		},
 		{
 			"path" : "/4_chapter805awakening",
 			"name" : "4_chapter805awakening",
 			"component" : A_CHAPTER805AWAKENING
 		},
 		{
 			"path" : "/5_chapter806thepassagebehindtherestriction",
 			"name" : "5_chapter806thepassagebehindtherestriction",
 			"component" : A_CHAPTER806THEPASSAGEBEHINDTHERESTRICTION
 		},
 		{
 			"path" : "/6_chapter807martialskillstoneforest",
 			"name" : "6_chapter807martialskillstoneforest",
 			"component" : A_CHAPTER807MARTIALSKILLSTONEFOREST
 		},
 		{
 			"path" : "/7_chapter808windandcloudriseagain",
 			"name" : "7_chapter808windandcloudriseagain",
 			"component" : A_CHAPTER808WINDANDCLOUDRISEAGAIN
 		},
 		{
 			"path" : "/8_chapter809fourcrises",
 			"name" : "8_chapter809fourcrises",
 			"component" : A_CHAPTER809FOURCRISES
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js